/**
 * cn — utilidad ligera para combinar clases condicionales.
 * Acepta strings, arrays y objetos { clase: boolean }.
 * Evita una dependencia extra (clsx/tailwind-merge) para no inflar el bundle.
 *
 * @param {...(string|false|null|undefined|Record<string, boolean>|Array)} args
 * @returns {string}
 */
export function cn(...args) {
  const out = []
  for (const arg of args) {
    if (!arg) continue
    if (typeof arg === 'string' || typeof arg === 'number') {
      out.push(String(arg))
    } else if (Array.isArray(arg)) {
      const inner = cn(...arg)
      if (inner) out.push(inner)
    } else if (typeof arg === 'object') {
      for (const key in arg) {
        if (arg[key]) out.push(key)
      }
    }
  }
  return out.join(' ')
}

export default cn
